import styled from 'styled-components';

export const SupportMaterialWrapper = styled.div`
  background: linear-gradient(122.66deg, #5e287e 0%, #d82e88 101.2%);
  border-radius: 15px;
  padding: 25px 15px;
  margin-top: 60px;

  h4 {
    color: #fff;
    font-size: var(--font-large);
    font-family: 'Inter Bold';
    margin-bottom: 18px;
  }

  .extra-material-card {
    background-color: var(--color-light-pink);
    border-radius: 11px;
    position: relative;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    a {
      text-decoration: none;
      padding: 15px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    p {
      color: var(--color-text);
    }
  }

  .material-type {
    color: var(--color-light-pink);
    background-color: var(--primary-color);
    border-radius: 25px;
    padding: 4px 14px;
    font-size: var(--font-smallest);
    margin-bottom: 10px;
    display: inline-block;
  }
`;
